import { Component, OnDestroy, OnInit } from "@angular/core";
import { AbstractControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Observable } from "rxjs/Observable";
import { SpecialAuthCodesService } from "../../services/specialauthcodes.service";

@Component({
  templateUrl: "./specialauthcodes.component.html",
  styleUrls: ["./specialauthcodes.component.css"]
})
export class SpecialAuthCodesComponent implements OnInit, OnDestroy {
  public spclAuthCodes: any;
  public specialAuthCodeForm: FormGroup;
  public specialAuthCodeId: string;
  public displayModal: boolean = false;
  public specialAuthCodeModalTitle: string;

  constructor(private specialauthcodesService: SpecialAuthCodesService, public fb: FormBuilder) { }

  ngOnInit() {
    Observable.forkJoin(
      this.specialauthcodesService.getSpecialAuthCodes()
    ).subscribe(([resp]) => {
      this.spclAuthCodes = resp.body;
    });
    this.specialAuthCodeForm = this.fb.group({
      specialAuthCodeName: ["", [Validators.required, Validators.pattern(/^[A-Za-z0-9_'\-\/().,]+$/)]],
      specialAuthCodeDescription: ["", [Validators.required]],
      specialAuthCodeStatus: ["", [Validators.required]],
      specialAuthCodeDisplayOrder: ["", [Validators.required, Validators.pattern(/^[0-9]+$/)]],
    });
  }

  onNew() {
    this.specialAuthCodeModalTitle = "Add Special Auth Code";
    this.specialAuthCodeForm.setValue({
      specialAuthCodeName: "",
      specialAuthCodeDescription: "",
      specialAuthCodeStatus: "A",
      specialAuthCodeDisplayOrder: "",
    });
    this.specialAuthCodeForm.controls["specialAuthCodeName"].enable();
    this.displayModal = true;
  }

  onEdit(item) {
    this.specialAuthCodeModalTitle = "Edit Special Auth Code";
    this.specialAuthCodeId = item.SPECIAL_AUTH_CODE_ID;
    this.specialAuthCodeForm.setValue({
      specialAuthCodeName: item.CODE_NM,
      specialAuthCodeDescription: item.CODE_DS,
      specialAuthCodeStatus: item.STATUS_CD,
      specialAuthCodeDisplayOrder: item.DISPLAY_ORDER_NO
    });
    this.specialAuthCodeForm.controls["specialAuthCodeName"].disable();
    this.displayModal = true;
  }

  onSave() {
    if (this.specialAuthCodeId) {
      const updatedSpecialAuthCode = {
        CODE_DS: this.specialAuthCodeForm.value.specialAuthCodeDescription,
        STATUS_CD: this.specialAuthCodeForm.value.specialAuthCodeStatus,
        DISPLAY_ORDER_NO: this.specialAuthCodeForm.value.specialAuthCodeDisplayOrder
      };
      this.specialauthcodesService.updateSpecialAuthCodes(this.specialAuthCodeId, updatedSpecialAuthCode).subscribe(resp => {
        if (resp) {
          this.onClose();
          this.ngOnInit();
        }
      });
    } else {
      const newSpecialAuthCode = {
        CODE_NM: this.specialAuthCodeForm.value.specialAuthCodeName,
        CODE_DS: this.specialAuthCodeForm.value.specialAuthCodeDescription,
        STATUS_CD: this.specialAuthCodeForm.value.specialAuthCodeStatus,
        DISPLAY_ORDER_NO: this.specialAuthCodeForm.value.specialAuthCodeDisplayOrder
      };
      this.specialauthcodesService.createSpecialAuthCodes(newSpecialAuthCode).subscribe(resp => {
        if (resp) {
          this.onClose();
          this.ngOnInit();
        }
      });
    }
  }

  onClose() {
    this.specialAuthCodeId = null;
    this.displayModal = false;
    this.specialAuthCodeForm.reset();
  }

  codeDisplay(code: string) {
    switch (code) {
      case "A": return "Active";
      case "I": return "Inactive";
      default: "None";
    }
  }

  required(name: string) {
    const ctrl = this.specialAuthCodeForm.get(name);
    return this.controlInvalid(ctrl) && ctrl.errors.required;
  }

  valid(name: string) {
    const ctrl = this.specialAuthCodeForm.get(name);
    return this.controlInvalid(ctrl) && ctrl.errors.pattern;
  }

  controlInvalid(ctrl: AbstractControl) {
    return ctrl.invalid && (ctrl.dirty || ctrl.touched);
  }

  formInvalid() {
    return this.specialAuthCodeForm.status === "INVALID";
  }

  ngOnDestroy() { }
}



// WEBPACK FOOTER //
// ./client/app/internal/accmgr/ba/special-authorization-codes/specialauthcodes.component.ts